import React from 'react';
import ConfirmDialog, { TEAL, ENRICH_DEFAULTS, useEnrichAction } from './EnrichConfirmDialog';
import { totalActionable, actionableByEntity } from '../../lib/composition';

// A compact "Enrich my data" prompt for the Quality tab, styled to sit under the stat
// cards. It only appears when enrichment can still fill something (actionable gaps > 0);
// once exhausted it renders nothing. Shares the Pipeline tab's spend-confirm dialog.
const fmt = (n) => Number(n || 0).toLocaleString('en-US');
const ENTITY_LABEL = { companies: 'companies', people: 'people', jobs: 'jobs' };

export default function EnrichDataCard({ coverage, onRunEnrichment, busy, job }) {
  // Hooks before any early return (rules-of-hooks).
  const { confirming, setConfirming, selectedSteps, toggleStep, runEnrich } = useEnrichAction(onRunEnrichment);

  const gaps = totalActionable(coverage);
  if (!(gaps > 0)) return null;

  const jobRunning = job?.status === 'running';
  const jobActive = jobRunning || job?.status === 'paused';
  const breakdownText = actionableByEntity(coverage)
    .slice(0, 3)
    .map((b) => `${fmt(b.actionable)} in ${ENTITY_LABEL[b.entity] || b.entity}`)
    .join(' · ');

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex flex-col sm:flex-row sm:items-center gap-4">
      <div className="min-w-0 flex-1">
        <p className="text-sm text-gray-900">
          SignalCue can fill <strong className="tabular-nums">{fmt(gaps)}</strong> more empty fields — websites,
          industries, locations and LinkedIn pages your ATS never had.
        </p>
        {breakdownText && <p className="text-xs text-gray-500 mt-1 tabular-nums">{breakdownText}</p>}
      </div>
      <div className="flex-none sm:text-right">
        <button
          type="button"
          onClick={() => setConfirming(true)}
          disabled={busy || jobActive}
          className="px-5 py-2.5 rounded-lg text-sm font-semibold text-white shadow-sm disabled:opacity-60 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 whitespace-nowrap"
          style={{ background: TEAL, '--tw-ring-color': TEAL }}
        >
          {busy || jobRunning ? 'Enriching…' : job?.status === 'paused' ? 'Paused' : 'Enrich my data'}
        </button>
        <p className="text-[11px] text-gray-400 mt-1.5 text-center">Uses AI · we&apos;ll confirm first</p>
      </div>

      <ConfirmDialog
        open={confirming}
        onCancel={() => setConfirming(false)}
        onConfirm={runEnrich}
        companies={ENRICH_DEFAULTS.COMPANY_CAP}
        people={ENRICH_DEFAULTS.PEOPLE_CAP}
        busy={busy}
        selectedSteps={selectedSteps}
        onToggleStep={toggleStep}
      />
    </div>
  );
}
